export const APP_NAME = 'easyPOM'
